export default __webpack_public_path__ + "static/media/feature-compliance-3.311487c0.png";